
import Vue from "vue";
// tabs
import WaitingTab from "@/components/profile/views/tabs/WaitingTab.vue";
import InProgressTab from "@/components/profile/views/tabs/InProgressTab.vue";
import DoneTab from "@/components/profile/views/tabs/DoneTab.vue";
import store from "@/store";

export default Vue.extend({
  name: "ProfilePurchases",
  components: {
    // AppWarn,
    WaitingTab,
    InProgressTab,
    DoneTab,
  },
  data() {
    return {
      tab: null,
    };
  },
  created() {
    if (!store.state.panel.invoices.length) {
      setTimeout(function () {
        store.dispatch("panel/getInvoices");
      }, 1000);
    }
  },
});
